import { Icon } from "@bluebottlecoffee/design-system/components";
import { APIProvider, AdvancedMarker, Map } from "@vis.gl/react-google-maps";
import { FunctionComponent } from "react";

interface CafeDetailMapProps {
  lat: number;
  lng: number;
}

export const CafeDetailMap: FunctionComponent<CafeDetailMapProps> = ({
  lat,
  lng,
}) => (
  <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY}>
    <Map
      defaultCenter={{
        lat,
        lng,
      }}
      center={{
        lat,
        lng,
      }}
      defaultZoom={15}
      minZoom={15}
      maxZoom={15}
      reuseMaps
      gestureHandling="cooperative"
      disableDefaultUI
      // mapId connects the map to custom style in google cloud console
      // https://console.cloud.google.com/google/maps-apis/studio/styles/381754a19710815e?project=blue-bottle-coffee-4b969
      mapId="e60112b7748353db"
      controlled
    >
      <AdvancedMarker
        position={{
          lat,
          lng,
        }}
      >
        <Icon name="bbcMapPin" outline />
      </AdvancedMarker>
    </Map>
  </APIProvider>
);
